import { useEffect } from 'react';
import { useMatch, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { Stack } from '@mui/material';

// The floating AutoJerry reviews toast is superseded by the always-visible
// TrustStrip on the home page (see pages/Root). Kept commented, not removed,
// in case we want the toast back for other pages later.
// import AutoJerryReviewsBanner from 'components/AutoJerryReviewsBadge';
// import { useAutoJerryReviewsBannerSession } from 'components/AutoJerryReviewsBadge/useAutoJerryReviewsBannerSession';

import Footer from './Footer';
import NavBarWithContent from './NavBarWithContent';
import { getSpacing } from './utils';

const Layout: React.FC = () => {
  const isRootPath = !!useMatch('/');
  const { pathname } = useLocation();
  // const { shouldShowBanner, suppressBanner } = useAutoJerryReviewsBannerSession(isRootPath);

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: pathname });
  }, [pathname]);

  return (
    <Stack spacing={getSpacing(isRootPath)} sx={{ minHeight: '100vh' }}>
      <NavBarWithContent />
      {/* {shouldShowBanner && <AutoJerryReviewsBanner onDismiss={suppressBanner} />} */}
      <Footer />
    </Stack>
  );
};

export default Layout;
